"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorDayOfMonth = exports.MonthlyEventMonthKey = exports.AnnualSubscriptionAccountType = exports.StripeClientMode = exports.AmountInDollars = exports.AmountInCents = exports.StripeBillingPortalConfiguration = exports.StripePrice = exports.StripeProduct = exports.BillingInterval = exports.PaymentMethodStatus = exports.SubscriptionStatus = exports.SubscriptionStatusOrdered = exports.PaymentSubscriptionSubtype = exports.PaymentSubscriptionType = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
/**
 * These values are used as the metadata key "type" on a stripe subscription and customer
 *
 * All customers have a "type" field, because we backfilled them (packages/cli/src/commands/stripe/backfill-customer-metadata.ts)
 * But there may be subscriptions that are missing a type metadata field, in which case we should fall back to the field
 * on the customer (will always be "user")
 */
exports.PaymentSubscriptionType = zod_1.default.enum(["organization", "user"]);
/**
 * These values are used as the metadata key "subtype" on a stripe subscription
 *
 * Old subscriptions may be missing a "subtype" field, in which case use the value "account"
 */
exports.PaymentSubscriptionSubtype = zod_1.default.enum(["account", "copilotCredits", "generatedTrial", "addon"]);
/**
 * Ordered list of all Stripe {@link https://docs.stripe.com/billing/subscriptions/overview#subscription-statuses statuses}
 *
 * We consider statuses near the start of this list as "winning" over statuses nearer to the end, for the purposes
 * of deciding the status of a subscription subtype, where multiple subscriptions have existed over time.
 */
exports.SubscriptionStatusOrdered = [
    "active",
    "trialing",
    "past_due",
    "unpaid",
    "incomplete",
    "incomplete_expired",
    "paused",
    "canceled",
];
/**
 * New subscription status field values
 *
 * Including all Stripe {@link https://docs.stripe.com/billing/subscriptions/overview#subscription-statuses statuses}
 */
exports.SubscriptionStatus = zod_1.default.enum(exports.SubscriptionStatusOrdered);
/**
 * Status of the payment method for a subscription.
 *
 * These values align with Stripe's concept of whether a payment method is attached:
 * - "none": No default_payment_method on subscription or customer.invoice_settings
 * - "attached": A payment method is set on subscription or customer.invoice_settings.default_payment_method
 */
exports.PaymentMethodStatus = zod_1.default.enum(["none", "attached"]);
exports.BillingInterval = zod_1.default.enum(["monthly", "annual"]);
exports.StripeProduct = zod_1.default.string().refine((val) => /^prod_/.test(val));
exports.StripePrice = zod_1.default.string().refine((val) => /^price_/.test(val));
exports.StripeBillingPortalConfiguration = zod_1.default
    .string()
    .refine((val) => /^bpc_/.test(val));
exports.AmountInCents = zod_1.default.number().finite().int().nonnegative().brand();
// Dealing with non-integer prices? Use cents, and centsToDisplay()/displayToCents() to show them in dollars instead of this type
exports.AmountInDollars = zod_1.default.number().finite().int().nonnegative().brand();
exports.StripeClientMode = zod_1.default.enum(["test", "live"]);
/**
 * The account type for annual subscription schedules
 *
 * This is a subset of PaymentSubscriptionType, used to identify whether the schedule
 * belongs to a user or an organization.
 */
exports.AnnualSubscriptionAccountType = zod_1.default.enum(["user", "organization"]);
/**
 * Monthly event key format for idempotency (e.g., "2025-12")
 *
 * Used to ensure we only fire one monthly event per subscription per month.
 */
exports.MonthlyEventMonthKey = zod_1.default
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .refine((_val) => true);
/**
 * Day of month for billing anchor (1-31)
 *
 * Used to determine which day of the month to fire synthetic monthly events.
 * For months with fewer days, the event fires on the last day of the month
 * (e.g., anchor day 31 fires on day 30 for April, day 28/29 for February).
 */
exports.AnchorDayOfMonth = zod_1.default.number().int().min(1).max(31);
//# sourceMappingURL=structure.js.map